module.exports = __webpack_public_path__ + "static/media/success.ee144a2c.svg";